/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { createContext, useContext, useEffect, useState } from "react";
import { providers } from "dc-core";

const ThemeContext = createContext("light");

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState("light");

  useEffect(() => {
    providers.theme().then(themeApi =>
      themeApi.getTheme().then(theme => {
        setCurrentTheme(theme);
        themeApi.subscribe(setCurrentTheme);
      })
    );
  }, []);

  return <ThemeContext.Provider value={currentTheme}>{children}</ThemeContext.Provider>;
};

export const withTheme = WrappedComponent => ({ ...props }) => {
  const theme = useContext(ThemeContext);
  return <WrappedComponent currentTheme={theme} {...props} />;
};

export default ThemeContext;
